/** @format */

export const DEFAULT_TEST_ID = 'kit-stat-tile';
